import { render, staticRenderFns } from "./r-item-page.vue?vue&type=template&id=5208e70d"
import script from "./r-item-page.vue?vue&type=script&lang=js"
export * from "./r-item-page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5208e70d')) {
      api.createRecord('5208e70d', component.options)
    } else {
      api.reload('5208e70d', component.options)
    }
    module.hot.accept("./r-item-page.vue?vue&type=template&id=5208e70d", function () {
      api.rerender('5208e70d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/item/r-item-page.vue"
export default component.exports